import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from 'gatsby-background-image'

const VideoPopup = () => {
// if toggler is updated when lightbox is closed it will open it
// if toggler is updated when lightbox is opened it will close it
const [toggler, setToggler] = useState(false);

const data = useStaticQuery(graphql`
    query VideoQuery {
        video2: file(relativePath: {eq: "video-2.jpg"}) {
            childImageSharp {
              fluid(maxWidth: 755, maxHeight: 500) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
          videoBtn: file(relativePath: {eq: "video_btn.png"}) {
            childImageSharp {
              fixed(width: 135, height: 135) {
                  ...GatsbyImageSharpFixed_withWebp_noBase64
              }
            }
          }
          videoImgBg: file(relativePath: {eq: "video_img_bg.png"}) {
            childImageSharp {
              fluid(maxWidth: 755, maxHeight: 300) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
    }
  `)

return (
<>
<div className="sc-bwzfXH row uTxCW">
    <div className="col-12 col-lg-9">
        <div className="sc-jwKygS video_bg_red fBWxJW">
            <a  onClick={() => setToggler(!toggler)}>
                <Img fluid={data.video2.childImageSharp.fluid} loading="lazy"/>
                    <div className="vidio_icon">
                    <Img fixed={data.videoBtn.childImageSharp.fixed} loading="lazy"/>
                            </div>
                            
                            <BackgroundImage fluid={data.videoImgBg.childImageSharp.fluid} className="bg_abs" loading="lazy">
                                    <span>GET JUSTICE FOR YOUR PAIN AND SUFFERING</span>
                                    </BackgroundImage>
                                    
                                    </a>
                                    </div>
                                    </div>
                                    </div>
<FsLightbox
toggler={toggler}
sources={[
<iframe src="https://player.vimeo.com/video/367865811?autoplay=1" width="1920px" height="1080px"
frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />
]}
/>
</>
);
}

  export default VideoPopup